import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
/**
 * Forwarded ref points at the underlying `<input>`. The component is
 * `forwardRef`'d at the source so callers (e.g., Radix `<Tooltip>`)
 * receive a real DOM ref via composition — without each callsite
 * needing to wrap `<AcCheckbox>` in a `<div>`.
 */
export const AcCheckbox = forwardRef(function AcCheckbox({ children, checked, onChange, disabled = false, ariaLabel, className, id, name, dataTestId, }, ref) {
    const labelClass = className ? `ac-checkbox ${className}` : 'ac-checkbox';
    const handleChange = (event) => {
        onChange(event.target.checked);
    };
    return (_jsxs("label", { className: labelClass, children: [_jsx("input", { ref: ref, className: "ac-checkbox__input", type: "checkbox", checked: checked, onChange: handleChange, disabled: disabled, "aria-label": ariaLabel, id: id, name: name, "data-testid": dataTestId }), _jsx("span", { className: "ac-checkbox__label", children: children })] }));
});
//# sourceMappingURL=AcCheckbox.js.map